import { render, staticRenderFns } from "./right-chart.vue?vue&type=template&id=f5a23ec2&scoped=true&"
import script from "./right-chart.vue?vue&type=script&lang=js&"
export * from "./right-chart.vue?vue&type=script&lang=js&"
import style0 from "./right-chart.vue?vue&type=style&index=0&id=f5a23ec2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a23ec2",
  null
  
)

export default component.exports